export const fetchJson = async (url, options = {}) => {
    try {
        const response = await fetch(url, {
            credentials: 'same-origin',
            headers:     {Accept: 'application/json'},
            ...options,
        });

        return response.ok ? await response.json() : null;
    } catch {
        return null;
    }
};
